/**
 * web端路由
 */
import { RouteRecordRaw } from "vue-router";

export const routesTest: Array<RouteRecordRaw> = [
    {
        path: "/testimageeditor",
        name: "TestImageEditor",
        component: () => import("@/views/test/TestImageEditor.vue"),
        meta: {
            level: 1,
        },
    },
    {
        path: "/testgooglemap",
        name: "TestGoogleMap",
        component: () => import("@/views/test/TestGoogleMap.vue"),
        meta: {
            level: 1,
        },
    },
];
